'use client';
import { useEffect, useState } from 'react';
import Link from 'next/link';
import { useRouter } from 'next/navigation';

export default function HoldingNews({ articles, totalArticles, currentPage, heading }) {
  const router = useRouter();
  const [loaded, setLoaded] = useState(articles);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setLoaded(previous => currentPage === 1 ? articles : [...new Map([...previous, ...articles].map(a => [a.id, a])).values()]);
    setLoading(false);
  }, [articles, currentPage]);
  return <section className="holding-news">
    <h1 className="holding-page-title">{heading}</h1>
    <div>{loaded.map(article => <article className="holding-news-row" key={article.id}>
      <Link href={`/${article.slug}`}>
        {article.image && <img src={article.image} alt={article.imageAlt || ''} />}
        <h2>{article.title}</h2>
      </Link>
    </article>)}</div>
    {currentPage * 4 < totalArticles && <button type="button" disabled={loading} onClick={() => {
      setLoading(true); const url = new URL(window.location.href); url.searchParams.set('page', String(currentPage + 1));
      router.push(`${url.pathname}${url.search}`, { scroll: false });
    }}>{loading ? 'Loading…' : 'Load more'}</button>}
  </section>;
}
